import React from 'react';

import { Alert, Box } from '@mui/material';

interface Props {
  name: string;
}

export default function ComingSoon({ name }: Props) {
  return (
    <Box>
      <Alert severity="info">
        <strong>{name}</strong> is coming soon.
      </Alert>
    </Box>
  );
}

/**
 * Factory that returns a named component rendering <ComingSoon/>. Use this when
 * wiring placeholder tabs into a section map so we don't need a separate file
 * per placeholder. Drop the factory call once the real page exists.
 */
export function createComingSoon(name: string): React.FC {
  // eslint-disable-next-line react/function-component-definition, react/no-multi-comp -- factory intentionally returns a component
  const Component: React.FC = () => <ComingSoon name={name} />;
  Component.displayName = `ComingSoon[${name}]`;
  return Component;
}
